import React from 'react';

function Home() {
    return(
        <div className="home">
           <h1>Med-Cabinet</h1>
        </div>
    )
}

export default Home;